import clsx from 'clsx';
import { SelectItemSearchWidget } from '@/core/SelectItemSearchWidget.molecule';
import { Modal } from '@seeqdev/qomponents';
import type { SelectItemSearchWidgetProps } from '@/core/SelectItemSearchWidget.molecule';
import type { SelectedSearchItem } from '@/search/search.types';

export interface SelectItemSearchModalProps extends SelectItemSearchWidgetProps {
  onClose: () => void;
  showHeaderCloseButton?: boolean;
  testId?: string;
  modalId: string;
  isMultiple?: boolean;
  header: {
    title: string;
    isEditable?: boolean;
    isTitleRequired?: boolean;
    titleIcon?: string;
    isInvalid?: boolean;
    placeholder?: string;
    onChange?: (e: any) => void;
  };
  /** HTML that should appear above search widget, but below title */
  body: React.JSX.Element | HTMLElement | null;
  footer?: React.JSX.Element;
  selectItems?: SelectedSearchItem[];
  showRecentlyAccessed?: boolean;
  onSubmit?: () => void;
  initialItemTable?: SelectedSearchItem;
  initialHierarchy?: SelectedSearchItem;
  /** Optional filter function to further filter items in the search results */
  additionalItemFilter?: (items: SelectedSearchItem[]) => SelectedSearchItem[];
  initialScalingTable?: SelectedSearchItem;
  disableSubmitButton?: boolean;
}

export const SelectItemSearchModal = ({
  onClose,
  header,
  body,
  footer,
  showHeaderCloseButton = true,
  onSelect,
  iconPartialTooltipKey,
  selectItems,
  validateItem,
  scopeIds,
  excludeGloballyScoped = false,
  testId = 'selectAssetModal',
  modalId,
  searchTypes,
  isMultiple,
  selectAllCallback,
  areAllSelected = () => false,
  showPinnedAssets = false,
  showOnlyScopedAssets = false,
  showOnlyConditions = false,
  showRecentlyAccessed = false,
  overrideWorkbookId,
  onSubmit,
  filterByWorkbook,
  itemTypeToShowInOverview,
  overviewLabel,
  showCreateNewItem = false,
  onCreateNewItem,
  createNewItemMessage = '',
  createNewItemLabel = '',
  doNotDisableOnEdit = false,
  restrictExploration = false,
  initialItemTable,
  initialHierarchy,
  initialScalingTable,
  disableSubmitButton = !selectItems?.length,
  additionalItemFilter,
}: SelectItemSearchModalProps) => {
  return (
    <Modal
      open={true}
      onClose={onClose}
      size="sm"
      dialogClassName="scrollableSearchModal"
      testId={testId}
      title={header.title}
      isTitleEditable={header.isEditable}
      titleRequired={header.isTitleRequired}
      inputExtraClassNames={clsx('width-maximum', {
        'error-border': header.isInvalid,
      })}
      titlePlaceholder={header.placeholder}
      onTitleChanged={header.onChange}
      titleIcon={header.titleIcon}
      hideCloseIcon={!showHeaderCloseButton}
      modalFooter={footer}
      onSubmit={onSubmit}
      disableSubmitButton={disableSubmitButton}>
      <>
        {body}
        <SelectItemSearchWidget
          onSelect={onSelect}
          iconPartialTooltipKey={iconPartialTooltipKey}
          selectedItems={selectItems}
          validateItem={validateItem}
          scopeIds={scopeIds}
          excludeGloballyScoped={excludeGloballyScoped}
          modalId={modalId}
          searchTypes={searchTypes}
          isMultiple={isMultiple}
          selectAllCallback={selectAllCallback}
          areAllSelected={areAllSelected}
          showPinnedAssets={showPinnedAssets}
          showOnlyScopedAssets={showOnlyScopedAssets}
          showOnlyConditions={showOnlyConditions}
          showRecentlyAccessed={showRecentlyAccessed}
          overrideWorkbookId={overrideWorkbookId}
          filterByWorkbook={filterByWorkbook}
          itemTypeToShowInOverview={itemTypeToShowInOverview}
          overviewLabel={overviewLabel}
          showCreateNewItem={showCreateNewItem}
          onCreateNewItem={onCreateNewItem}
          createNewItemMessage={createNewItemMessage}
          createNewItemLabel={createNewItemLabel}
          doNotDisableOnEdit={doNotDisableOnEdit}
          restrictExploration={restrictExploration}
          initialItemTable={initialItemTable}
          initialHierarchy={initialHierarchy}
          initialScalingTable={initialScalingTable}
          additionalItemFilter={additionalItemFilter}
        />
      </>
    </Modal>
  );
};
